export default "__VITE_ASSET__OfTQlu5I__"